
            const data = {"name":"chevron-blue","data":{"width":"16","height":"9","viewBox":"0 0 16 9","data":"<path pid=\"0\" fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M.293.293a1 1 0 0 1 1.414 0L8 6.586 14.293.293a1 1 0 1 1 1.414 1.414l-7 7a1 1 0 0 1-1.414 0l-7-7a1 1 0 0 1 0-1.414Z\" _fill=\"#336DFF\"/>","originalColors":[{"type":"fill","color":"#336DFF"}],"stopColors":[]}}
        
                    module.exports = data
                    